import styled from "styled-components";

export const BarChartWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const CustomTooltipWrapper = styled.div`
    border: 1px solid #d1d1d1;
    background-color: white;
    padding: 5px 10px;
`;
